import style from "./style.module.scss";

export default function SumBoxes(props) {
  const { elements, ...rest } = props;
  return (
    <div className={style.sum_box} {...rest}>
      {elements?.map(__value => (
        <div key={__value} className={style.box} data-color={__value?.color}>
          <div>
            <p>{__value.label}</p>
            <p>{__value.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
